import {
    faDashboard,
    faUser,
    faKey,
    faBuilding,
    faHome,
    faCheckCircle,
    faThLarge,
    faStore,
    faMoneyBill,
    faUsersCog,
    faBars,
    faListUl,
    faHistory
} from "@fortawesome/free-solid-svg-icons";

import { baseUrl } from "../../Redux/BaseUrl/baseurl";

export const accountManagementTableHeaders = [
    "Sr. No",
    "Name",
    "ID",
    "Contact",
    "Payment Status",
    "Actions"
];

export const userTableHeaders = [
    "Sr.NO",
    "First Name",
    "Last Name",
    "Contact",
    "Email",
    "User Role",
    "KYC Status",
    "Actions"
];
export const Paymenttabelheaders = [
    "Property ID",
    "Amount",
    "EMI No",
    "Date",
    "Transactin Receipt",
    "Action"
];

export const AgentPaymenttabelheaders = [
    "Property ID",
    "Property Name",
    "Amount",
    "Date",
    "Action"
];

export const propertyListingTableHeaders = [
    "Sr.No",
    "Title",
    "Images",
    "Address",
    "Price"
    // "PropertyStatus",
    // "Built In",
    // "Subcategory",
];

export const CurrentPoolTableHeaders = [
    "Sr.No",
    "Pool Name",
    "Lots",
    "Base Price",
    "Total investor",
    "Action"
];

export const typesOfUsers = {
    user: "Buyer/Seller",
    investor: "Investor",
    agent: "Agent",
    lawyer: "Lawyer",
    evaluator: "Evaluator"
};

export const usersAPIs = {
    evaluator: {
        getList: () => `${baseUrl}/users/evaluator`
    },
    user: {
        getList: () => `${baseUrl}/users/user` // buyer or seller   ${baseUrl}/users/user
    },
    lawyer: {
        getList: () => `${baseUrl}/users/lawyer` // lawyer
    },
    investor: {
        getList: () => `${baseUrl}/users/investor` // investor
    },
    agent: {
        getList: () => `${baseUrl}/users/agent`
    },
    getUserDetails: id =>
        id
            ? `${baseUrl}/users/UserDetails/${id}`
            : `${baseUrl}/users/UserDetails`,
    getEvaluatorLeads: id => `${baseUrl}/propertyevaluator/getleadlist/${id}`
};

export const DummyTransactions = [
    {
        name: "John Doe",
        userid: "U123",
        date: "01/15/2002",
        amount: "120000"
    },
    {
        name: "Alice Johnson",
        userid: "U456",
        date: "05/22/2004",
        amount: "75000"
    },
    {
        name: "Bob Smith",
        userid: "U789",
        date: "11/07/2001",
        amount: "200000"
    },
    {
        name: "Eva White",
        userid: "U234",
        date: "09/18/2005",
        amount: "98000"
    },
    {
        name: "Michael Brown",
        userid: "U567",
        date: "02/09/2003",
        amount: "150000"
    },
    {
        name: "Sophia Davis",
        userid: "U890",
        date: "07/30/2000",
        amount: "300000"
    },
    {
        name: "Sophia Davis",
        userid: "U890",
        date: "07/30/2000",
        amount: "300000"
    }
];

export const DummyEvaluatorHieredList = [
    {
        timestamp: "2021-01-01T12:00:00Z",
        document: "https://example51.com/document215"
    },
    {
        timestamp: "2020-02-15T15:30:00Z",
        document: "https://example41.com/document222"
    },
    {
        timestamp: "2020-04-05T08:45:00Z",
        document: "https://example12.com/document223"
    }
];

// Add headers
export const userExcelHeaders = [
    "Id",
    "First Name",
    "Last Name",
    "Email Id",
    "Password",
    "Role",
    "User Role",
    "Contact",
    "City",
    "Address",
    "Image",
    "Menu",
    "IsAdmin",
    "IsVerifiedByAdmin",
    "RejectReason",
    "IsBlockedByAdmin",
    "FreeAdvertLimit",
    "PaidAdvertLimit",
    "Mobileverified",
    "Status",
    "CreatedAt",
    "UpdatedAt"
]; // Fixed header names

export const userManagementSubMenu = {
    user: {
        path: "/userManagement/user",
        icon: "faShoppingCart",
        sidebarText: "Buyer/Seller"
    },
    investor: {
        path: "/userManagement/investor",
        icon: "faMoneyBill",
        sidebarText: "Investor"
    },
    agent: {
        path: "/userManagement/agent",
        icon: "faMoneyBill",
        sidebarText: "Agent"
    },
    lawyer: {
        path: "/userManagement/lawyer",
        icon: "faMoneyBill",
        sidebarText: "Lawyer"
    },
    evaluator: {
        path: "/userManagement/evaluator",
        icon: "faMoneyBill",
        sidebarText: "Evaluator"
    }
};

// export const usersAPIs = {
//   evaluator: {
//     getList: () => `${baseUrl}/users/evaluator`,
//     delete: (id) => `${baseUrl}/propertyevaluator/${id}`,
//   },
//   user: {
//     getList: () => `${baseUrl}/users/user`, // buyer or seller
//     delete: (id, role) => `${baseUrl}/${role}s/${id}`,
//     getKYC: (id) => `${baseUrl}/users/get-kyc/${id}`,
//     getDetailsByID: (id) =>
//       `${baseUrl}/users/UserDetails/${id}`,
//   },
//   lawyer: {
//     getList: (role) => `${baseUrl}/users/lawyer`, // lawyer
//     delete: (id) => `${baseUrl}/users/${id}`,
//   },
//   investor: {
//     getList: (role) => `${baseUrl}/users/investor`, // investor
//     delete: (id) => `${baseUrl}/users/${id}`,
//   },
//   agent: {
//     getList: () => `${baseUrl}/users/agent`,
//     getIntrestsList: () => "${baseUrl}/agents/getintrestlist",
//     delete: (id) => `${baseUrl}/users/${id}`,
//     getKYC: (id, role) => `${baseUrl}/${role}s/getKyc/${id}`,
//     getDetailsByID: (id) => `${baseUrl}/agents/${id}`,
//   },
// };

// export const sideBarItems1 = {
//   dashBoard: {
//     sidebarText: "DashBoard",
//     icon: "faDashboard",
//     path: "/Dashboard",
//     children: { count: 0 },
//   },
//   userManagement: {
//     sidebarText: "DashBoard",
//     path: "/Dashboard",
//     children: {
//       count: 5,
//       user: {
//         path: "/userManagement/user",
//         icon: "faShoppingCart",
//         sidebarText: "Buyer/Seller",
//       },
//       investor: {
//         path: "/userManagement/investor",
//         icon: "faMoneyBill",
//         sidebarText: "Investor",
//       },
//       agent: {
//         path: "/userManagement/agent",
//         icon: "faMoneyBill",
//         sidebarText: "Agent",
//       },
//       lawyer: {
//         path: "/userManagement/lawyer",
//         icon: "faMoneyBill",
//         sidebarText: "Lawyer",
//       },
//       evaluator: {
//         path: "/userManagement/evaluator",
//         icon: "faMoneyBill",
//         sidebarText: "Evaluator",
//       },
//     },
//   },
// };
